// extracted by mini-css-extract-plugin
module.exports = {"NewModal":"NewModal_NewModal__2gAUr","footerBtn":"NewModal_footerBtn__2eKU0","NewModal_padding":"NewModal_NewModal_padding__2TNZh"};